import { render, staticRenderFns } from "./alertItem.vue?vue&type=template&id=5086a0c9&scoped=true"
import script from "./alertItem.vue?vue&type=script&setup=true&lang=js"
export * from "./alertItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alertItem.vue?vue&type=style&index=0&id=5086a0c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086a0c9",
  null
  
)

export default component.exports